




































































import { defineComponent, ref } from '@vue/composition-api';
import ImportDataButton from '@/components/common/ImportDataButton.vue';
import { useAllResources } from '@/store/modules/resources';
import { useAllSamplingCollections } from '@/store/modules/samplingCollections';
import DownloadLabInventoryButton from './DownloadLabInventoryButton.vue';
import SamplingCollectionDelete from './SamplingCollectionDelete.vue';
import SamplingCollectionListItemContent from './SamplingCollectionListItemContent.vue';

export default defineComponent({
	components: {
		DownloadLabInventoryButton,
		ImportDataButton,
		SamplingCollectionListItemContent,
		SamplingCollectionDelete,
	},
	setup(_, { root }) {
		const selectedCollections = ref([]);

		const {
			isLoaded: resourcesAreLoaded,
			isLoading: resourcesAreLoading,
			hasError: resourcesHaveError,
			samplingCollections: submittedSamplingCollections,
		} = useAllResources(root.$store);
		const {
			isLoaded: draftsAreLoaded,
			isLoading: draftsAreLoading,
			hasError: draftsHaveError,
			samplingCollections: draftSamplingCollections,
		} = useAllSamplingCollections(root.$store);

		return {
			draftsAreLoaded,
			draftsAreLoading,
			draftsHaveError,
			resourcesAreLoaded,
			resourcesAreLoading,
			resourcesHaveError,
			submittedSamplingCollections,
			draftSamplingCollections,
			selectedCollections,
		};
	},
});
